import type { Role, UpdateClubKeyRequest, UserDto, UsersListResponse } from '../../api/types';
import type { UsersRepository } from '../../repositories/ApiUsersRepository';

export class UsersService {
  constructor(private readonly repo: UsersRepository) {}

  listUsers(): Promise<UsersListResponse> {
    return this.repo.listUsers();
  }

  listUsersByRole(params: { role: Role }): Promise<UsersListResponse> {
    return this.repo.listUsersByRole(params);
  }

  updateUserRole(params: { userId: string; role: Role }): Promise<UserDto> {
    return this.repo.updateUserRole(params);
  }

  updateCurrentUserClubKey(params: UpdateClubKeyRequest): Promise<UserDto> {
    return this.repo.updateCurrentUserClubKey(params);
  }
}
